import { render } from "./password.vue?vue&type=template&id=005b955b"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/horizontal/password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "005b955b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('005b955b', __exports__)) {
    console.log('reload')
    api.reload('005b955b', __exports__)
  }
  
  module.hot.accept("./password.vue?vue&type=template&id=005b955b", () => {
    console.log('re-render')
    api.rerender('005b955b', render)
  })

}


export default __exports__